// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"255":"4d818bc3","769":"b4797b5c"}[chunkId] + ".chunk.css";
};